import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { QueryOptions } from 'src/app/model/query-options';
import { LazyLoadEvent, MenuItem} from 'primeng/api';
import { Router } from '@angular/router';
import { NgxPermissionsService, NgxRolesService, NgxPermissionsModule } from 'ngx-permissions';
import { JobDescriptionService } from '@app/services/jobDescription.service';
import { Messages } from '@app/constants/constant';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import * as $ from 'jquery';
import { ScheduleInterviewService } from '@app/services/scheduleInterview.service';
import { CommonService } from '@app/services/common.service';
import { RecruiterServiceGet } from '@app/services/recruiterService.get';


@Component({
  selector: 'app-interviewer-dashboard',
  templateUrl: './interviewer-dashboard.component.html',
  styleUrls: ['./interviewer-dashboard.component.css'],
  providers: [NgxPermissionsService, NgxRolesService, NgxPermissionsModule]
})
export class InterviewerDashboardComponent implements OnInit {

  tableData: any[];
  cleanData: any[];
  @Input() records: [];
  totalRecords: number;
  totalPages: Number;
  @Input() columns: any[];
  @Input() innerColumns: any[];
  @Input() title: any[];
  @Input() refreshTable: any;
  @Input() pageSize: number = 20;

  @Input() apiService: any;
  @Output() openModal = new EventEmitter<any>();
  @Input() onChangeFieldsValues: boolean;

  selectedColumns: any[];
  jobFieldMapper = new Map<string, string>();
  filter: any = {
    jdFilter: '',
    intervieweTypeFilter: '',
    statusFilter: 2,
    recruiterFilter: ''
  }
  jdList: any;
  interviewTypeList: any;
  statusList: any;
  recruitersList: any;
  loading: boolean = false;
  exportColumns: any[];
  actionItems: MenuItem[];
  first: number = 0;
  pageSizeVar: number;
  cvSubmitId: any;
  cvSubmitted: string;
  cvShortListed: string;
  jdId: string;
  jdName: string;
  recruiterId: string;
  recruiterName: string;
  submitDate: string;
  jobPositionData: any;
  yearFilter: any;
  yearTimeout: any;
  sortField: any = 'startTime';
  sortOrder: any = '-1';
  date = null;
  listPageSize: number = 1000;
  status: any = "2";
  interviewerId: any; //= 'd16ebbe8-82c7-46b2-ae54-60ca3b6c59bd'
  user :any;
  interviewStepDetails:any;
  showTable:boolean=true;
  constructor(private _router: Router,
    private spinner: NgxSpinnerService,
    private _apiRecruiterGet:RecruiterServiceGet,
    public _apiJobDescription: JobDescriptionService,
    private _DatePipe: DatePipe,
    private _scheduleInterviewService: ScheduleInterviewService,
    private _commonService: CommonService) {
  }

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser'))['user'] : '';
    this.interviewerId=this.user.id;
    this.columns = [
      { field: 'candidateName', subfield: 'name', header: 'Candidate Name', sort: { required: true, sortBy: 'interview.applicant.firstName' },width:'13%' },
      { field: 'startDate', header: 'Date & Time', type: 'date', sort: { required: true, sortBy: 'startTime' } ,width:'12%'},
      { field: 'jobDescription', subfield: 'name', header: 'JD Name', params: { type: 'JDName' }, sort: { required: true, sortBy: 'interview.job.jobDescription.name' },width:'11%' },
      //{ field: 'email', header: 'Email', sort: { required: true, sortBy: 'interview.applicant.email' } },
      //{ field: 'phone', header: 'Mobile Number', sort: { required: true, sortBy: 'interview.applicant.phone' } },
      { field: 'interviewType', header: 'Interview Type', sort: { required: true, sortBy: 'interviewStep.name' },width:'11%' },
      { field: 'interviewMode', header: 'Interview Mode', sort: { required: true, sortBy: 'interviewMode.name' },width:'11%' },
      { field: 'feedbackStatus', subfield: 'name', header: 'Feedback Status',width:'10%'},
      { field: 'jobAssignedRecruiter', header: 'Recruiter',width:'10%' },
      { field: 'action', header: 'Actions', sort: { required: false }, params: { type: 'Redirect', component: '', icon: 'pi pi-pencil' },width:'16%' }
    ];

    this.innerColumns=[
      { field: 'candidateName', header: 'Candidate Name' ,},
      { field: 'date', header: 'Date & Time'},
      { field: 'interviewer', header: 'Interviewer'},
      { field: 'interviewType', header: 'Interview Type' },
      { field: 'interviewMode', header: 'Interview Mode' },
      { field: 'feedbackStatus', header: 'Feedback Status' },
      { field: 'interviewStatus', header: 'Interview Status' },
      { field: 'action', header: 'Actions' }
    ];

    this.pageSizeVar = this.pageSize;
    this.selectedColumns = this.columns;

    const params = this.queryParamsDropDownFilter();
    var sortParams = this.queryParams("name", 1, this.listPageSize);
    this._commonService.list(sortParams, 'interview-step').subscribe(res => {
      this.interviewTypeList = res;
    });
  
    this._apiRecruiterGet.list(params).subscribe(res => {
      this.recruitersList = res;
    });
    this._apiJobDescription.list(params, Messages.endpoint.jobDescription).subscribe(res => {
      this.jdList = res;
    });
    this.statusList = [
      { value: 2, label: 'Pending' },
      { value: 0, label: 'Draft' },
      { value: 1, label: 'Completed' }
    ]
  }

  cleanAPIData() {
    let data = [];
    this.tableData.forEach(item => {
      let cleanObj = {
        candidateName: item.applicantFullName,
        startDate: item.startDate,
        jobDescription: item.jobDescriptionName,
        interviewType: item.interviewStepName,
        interviewMode: item.interviewModeName,
        feedbackStatus: item.status===0?'Draft':item.status===2?'Pending':'Completed',
        jobAssignedRecruiter: item.assignedRecruiterNames.map(users=> {
          return users.firstName;
        }).join(', '),
        applicantId: item.applicantId,
        resumeUrl: item.resumeUrl ? item.resumeUrl : null,
        resumeFileName: item.resumeFileName ? item.resumeFileName : null,
        status: item.status,
        totalRecords: item.totalRecords,
        interviewStepMappingId: item.id,
        interviewId: item.interviewId,
        fileUrl: Messages.endpoint.fileUrlDomain + item.resumeUrl,
        interviewCount:item.interviewCount,
        showPreviousFeedback:item.showPreviousFeedback,
        feedbackSubmitted:item.feedbackSubmitted
      }
      data.push(cleanObj)
    })
    return data;
  }

  onYearChange(event, dt) {
    if (this.yearTimeout) {
      clearTimeout(this.yearTimeout);
    }
    this.yearTimeout = setTimeout(() => {
      dt.filter(event.value, 'year', 'gt');
    }, 250);
  }

  onLoad(event?: LazyLoadEvent) {
    this.spinner.show();
    this.loading = true;
    this.sortField = event.sortField == undefined ? 'startTime' : event.sortField;
    this.sortOrder = event.sortOrder ? event.sortOrder : -1;
    this.sortOrder = this.sortOrder === 1 ? 'ASC' : 'DESC';
    this.first = event.first ? event.first : 0;
    let dateRange = new Array();
    if (this.filter.jdFilter || this.filter.statusFilter || this.filter.recruiterFilter || this.filter.interviewTypeFilter || this.yearFilter) {
      if (this.yearFilter && this.yearFilter.length > 1) {
        dateRange.push(this._DatePipe.transform(this.yearFilter[1], 'dd/MM/yyyy'));
        dateRange.push(this._DatePipe.transform(this.yearFilter[0], 'dd/MM/yyyy'));
        this.date = dateRange.length > 1 ? dateRange[0] + '-' + dateRange[1] : null
      }

      var params = this.queryParams(this.sortField, this.sortOrder, this.pageSize, this.filter.statusFilter,
        this.filter.jdFilter, this.filter.recruiterFilter, this.filter.interviewTypeFilter, this.date)
      this.callService(params);
    }
    else {
      params = this.queryParams(this.sortField, this.sortOrder, this.pageSize, this.filter.statusFilter);
      this.callService(params);
    }
    this.loading = false;
  }

  queryParams(sortFieldName?: string, sortOrder?: any, pageSize?: any, status?: any, jdArr?: any, recruiterArr?: any, interviewTypeArr?: any, date?: any, pageNo?: any) {
    status = (status === undefined || status === "")? '2' : status;
    const queryParams = new Object();
    queryParams['pageParam'] = {
      page: pageNo ? pageNo :
        (this.first / this.pageSize),
      size: pageSize ? pageSize : this.pageSizeVar,
    };

    if (jdArr || recruiterArr || interviewTypeArr || date) {
      queryParams['viewInterviewerFilter'] = { 'jdName': jdArr, 'recruiters': recruiterArr, 'interviewType': interviewTypeArr, 'date': date }
    }
    const tableSortingQueryOption = new QueryOptions(queryParams);
    tableSortingQueryOption.queryMap.set('interviewerId', this.interviewerId);
    tableSortingQueryOption.queryMap.set('status', status);
    tableSortingQueryOption.queryMap.set('sortField', sortFieldName);
    tableSortingQueryOption.queryMap.set('sortOrder', sortOrder);
    tableSortingQueryOption.toQueryMap();
    return tableSortingQueryOption;
  }

  queryParamsDropDownFilter() {
    let queryParams = new Object();
    queryParams["sortParam"] = { sortField: "name", sortOrder: 1 };
    queryParams["pageParam"] = {
      page:
        this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
          : this.first / this.pageSize,
      size: this.pageSize
    };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
  }

  clearAllFilter(event) {
    this.spinner.show();
    this.filter.jdFilter = '';
    this.filter.interviewTypeFilter = '';
    this.filter.statusFilter = '';
    this.filter.recruiterFilter = '';
    this.yearFilter = '';
    this.onLoad(event);
  }

  gotoCandidateFeedback(interviewStepMappingId,interviewId) {
    window.sessionStorage.interviewrDashboardRedirect = 1;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
      this._router.navigate([`/candidate-evaluation`], { state: { data: { interviewStepMappingId: interviewStepMappingId,interviewId:interviewId} } });
    }, 400)
  }

  downloadCV(fileUrl) {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
      // console.log('CV downloaded: ', fileUrl);
      window.open(fileUrl, '_blank');
    }, 400)
  }

  callService(params) {
    this._scheduleInterviewService.list(params, 'interview/interviewer-list').subscribe(res => {
     this.spinner.hide();
      this.tableData = res;
      this.cleanData = this.cleanAPIData();
      if (this.cleanData.length > 0) {
        this.totalRecords = Number(this.cleanData[0].totalRecords);
        this.showTable=true;
      }
      else {
        this.totalRecords = 0;
        this.showTable=false;
      }
      //console.log("total records is"+this.totalRecords)
    });
  }

  gotoCreatePosition(){
    this._router.navigate(['manage-position']);
  }

  interviewStepdetails(interviewId,interviewStepMappingId){
    const queryParams = new Object();
    const tableSortingQueryOption = new QueryOptions(queryParams)
    tableSortingQueryOption.queryMap.set("interviewId",interviewId);
    tableSortingQueryOption.queryMap.set("existingInterviewStepMappingId",interviewStepMappingId);
    var endpoint =Messages.endpoint.interview_allinterviewStepMapping;
    this._scheduleInterviewService.list(tableSortingQueryOption,endpoint).subscribe(res => {
      console.log(res);
      let data = [];
      let interviewStepMappingData:any[];
      interviewStepMappingData=res;
      interviewStepMappingData.forEach(item => {
        let cleanObj = {
          candidateName: item.applicantFullName,
          date: item.startDate,
          interviewer:item.interviewerFullName,
          interviewType: item.interviewStep.name,
          interviewMode: item.interviewMode.name,
          feedbackStatus: item.status===0?'Draft':item.status===2?'Pending':'Completed',
          interviewStatus:item.interviewStepStatus.name,
          interviewStepMappingId: item.id,
          interviewId: item.interviewId,
          showPreviousFeedback:item.showPreviousFeedback,
          feedbackSubmitted:item.feedbackSubmitted
        }
        data.push(cleanObj)
      })

      this.interviewStepDetails=data;
    });

  }

}

